import { ErrorMessage } from "formik";
import React from "react";
import { twMerge } from "tailwind-merge";

type Props = {
  name?: string;
  checked: boolean;
  onChange: (checked: boolean, value: string) => void;
  value?: string;
  label?: string;
  disabled?: boolean;
  required?: boolean;
  extraClasses?: string;
  inputClasses?: string;
};

const ATMCheckbox = ({
  name,
  checked,
  onChange,
  value,
  label,
  disabled = false,
  required = false,
  extraClasses = "",
  inputClasses = "",
}: Props) => {
  return (
    <div
      className={twMerge(
        `relative flex items-center hover:bg-gray-100 ${extraClasses}`
      )}
    >
      <label className="inline-flex items-center w-full gap-2 cursor-pointer">
        <input
          type="checkbox"
          checked={checked}
          value={value}
          onChange={(e) => onChange(e.target.checked, e.target.value)}
          className={twMerge(
            `w-3 h-3 rounded-md ${inputClasses} cursor-pointer`
          )}
          disabled={disabled}
        />
        {label && (
          <span
            className={twMerge(
              `text-base ${
                disabled ? "text-slate-300" : "text-slate-600 font-medium"
              }`
            )}
          >
            {label}
          </span>
        )}
      </label>

      {name && (
        <ErrorMessage name={name}>
          {(errMsg) => (
            <p className="font-poppins absolute text-[14px] text-start mt-0 text-red-500">
              {" "}
              {errMsg}{" "}
            </p>
          )}
        </ErrorMessage>
      )}
    </div>
  );
};

export default ATMCheckbox;
